<script setup lang="ts">
import { ArrowLeft, Compass } from '@lucide/vue'
</script>

<template>
  <div class="not-found section-pad"><div class="not-found-orbit"><Compass/></div><p class="eyebrow">404 · LOST IN ORBIT</p><h1>这束光暂时没有抵达这里</h1><p>页面可能已经移动，或者链接尚未公开。</p><RouterLink class="button button-dark" to="/"><ArrowLeft/>回到首页</RouterLink></div>
</template>
